// // import React, { useEffect, useState } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import { toast, ToastContainer } from "react-toastify";
// // import DatePicker from "react-datepicker";
// // import "react-toastify/dist/ReactToastify.css";
// // import "react-datepicker/dist/react-datepicker.css";
// // import "./Invoice.css";
// // import "./InvoiceDetails.css";
// // import { apiWithLog } from "../utils/apiWithLog";

// // const InvoiceDetails = () => {
// //   const { CompID, InvoiceNo } = useParams();
// //   const navigate = useNavigate();

// //   const [invoice, setInvoice] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [parties, setParties] = useState([]);
// //   const [vehicles, setVehicles] = useState([]);
// //   const [services, setServices] = useState([]);
// //   const [filteredServices, setFilteredServices] = useState([]);
// //   const [activeServiceRow, setActiveServiceRow] = useState(null);
// //   const [hsnSummary, setHsnSummary] = useState([]);

// //   // ── NEW STATE: track which rows are in "Taxi Fare" mode ──
// //   const [taxiFareRows, setTaxiFareRows] = useState({}); // { rowIndex: true/false }
// //   const [dutySlipIdInput, setDutySlipIdInput] = useState({}); // { rowIndex: "123" }

// //   // NEW: fare package selection per row
// //   const [farePackagesByRow, setFarePackagesByRow] = useState({}); // { rowIndex: [pkg, pkg...] }
// //   const [selectedFareIdByRow, setSelectedFareIdByRow] = useState({}); // { rowIndex: fareId }
// //   const [pendingSlipByRow, setPendingSlipByRow] = useState({}); // { rowIndex: slipData } — holds slip until package chosen

// //   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
// //   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         const response = await axios.get(
// //           // `http://localhost:5000/api/invoice/details/${CompID}/${InvoiceNo}`
// //           `${BASE_API_URL}/invoice/details/${CompID}/${InvoiceNo}`
// //         );

// //         if (response.data.success && response.data.data) {
// //           const data = response.data.data;

// //           // Flatten items from hsnSummary
// //           const details = data.hsnSummary
// //             ? data.hsnSummary.flatMap((hsn) =>
// //                 hsn.items.map((item) => ({
// //                   date: item.date || "",
// //                   service: item.service || "",
// //                   Particulars: item.particulars || "",
// //                   quantity: item.quantity || "",
// //                   unit: item.unit || "",
// //                   rate: item.rate || 0,
// //                   amount: item.amount || 0,
// //                   HSNCODE: item.HSNCODE || "",
// //                   TaxRate: item.TaxRate || 0,
// //                   TaxID: item.TaxID || null,
// //                   TaxAmount: item.TaxAmount || 0,
// //                 }))
// //               )
// //             : [];

// //           setInvoice({
// //             ...data,
// //             details:
// //               details.length > 0
// //                 ? details
// //                 : [
// //                     {
// //                       date: "",
// //                       service: "",
// //                       Particulars: "",
// //                       quantity: "",
// //                       unit: "",
// //                       rate: 0,
// //                       amount: 0,
// //                       HSNCODE: "",
// //                       TaxRate: 0,
// //                       TaxID: null,
// //                       TaxAmount: 0,
// //                     },
// //                   ],
// //           });

// //           setHsnSummary(data.hsnSummary || []);
// //         } else toast.error("Invoice not found!");

// //         // Fetch dropdowns
// //         // const [partyRes, vehicleRes, serviceRes] = await Promise.all([
// //         //   // axios.get("http://localhost:5000/api/invoice/dropdowns"),
// //         //   // axios.get("http://localhost:5000/api/invoice/vehicles"),
// //         //   // axios.get("http://localhost:5000/api/invoice/services"),

// //         //   axios.get(`${BASE_API_URL}/invoice/dropdowns`),
// //         //   axios.get(`${BASE_API_URL}/invoice/vehicles/${CompID}`),
// //         //   axios.get(`${BASE_API_URL}/invoice/services`),
// //         // ]);

// //         const [partyRes, vehicleRes, serviceRes] = await Promise.all([
// //   axios.get(`${BASE_API_URL}/invoice/dropdowns/${CompID}`),
// //   axios.get(`${BASE_API_URL}/invoice/vehicles/${CompID}`),
// //   axios.get(`${BASE_API_URL}/invoice/services/${CompID}`),
// // ]);

// //         if (partyRes.data.success) setParties(partyRes.data.data);
// //         if (vehicleRes.data.success) setVehicles(vehicleRes.data.data);
// //         if (serviceRes.data.success) {
// //           setServices(serviceRes.data.data);
// //           setFilteredServices(serviceRes.data.data);
// //         }
// //       } catch (error) {
// //         console.error("❌ Error:", error);
// //         toast.error("Failed to fetch invoice details!");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchData();
// //   }, [CompID, InvoiceNo]);

// //   // Totals
// //   const totalAmount = invoice ? invoice.totalAmount || 0 : 0;
// //   const taxTotal = invoice ? invoice.totalTax || 0 : 0;
// //   const grandTotal = invoice ? invoice.grandTotal || 0 : 0;

// //   // ===== Handlers =====

// //   // Generic input change handler
// //   const handleInputChange = (field, value) => {
// //     setInvoice({ ...invoice, [field]: value });
// //   };

// //   // Party select
// //   const handlePartySelect = (e) => {
// //     const value = e.target.value;
// //     setInvoice({ ...invoice, PartyName: value });
// //   };

// //   // Vehicle select
// //   const handleVehicleSelect = (e) => {
// //     const value = e.target.value;
// //     const selectedVehicle = vehicles.find((v) => v.VehicleNo === value);
// //     setInvoice({
// //       ...invoice,
// //       VehicleNo: value,
// //       VehicleType: selectedVehicle ? selectedVehicle.VehicleType : "",
// //     });
// //   };

// //   // Service table change
// //   const handleDetailChange = (index, field, value) => {
// //     const updated = [...invoice.details];
// //     updated[index][field] = value;

// //     if (field === "quantity" || field === "rate") {
// //       const qty = parseFloat(updated[index].quantity) || 0;
// //       const rate = parseFloat(updated[index].rate) || 0;
// //       updated[index].amount = qty * rate;
// //       updated[index].TaxAmount =
// //         (updated[index].amount * (parseFloat(updated[index].TaxRate) || 0)) /
// //         100;
// //     }

// //     setInvoice({ ...invoice, details: updated });
// //   };

// //   const handleServiceChange = (index, value) => {
// //     const updated = [...invoice.details];
// //     updated[index].service = value;
// //     setActiveServiceRow(index);

// //     // Special case: Taxi Fare selected
// //     if (value === "Taxi Fare") {
// //       setTaxiFareRows((prev) => ({ ...prev, [index]: true }));
// //       setInvoice({ ...invoice, details: updated });
// //       setActiveServiceRow(null); // close dropdown
// //       return; // don't run normal service-matching logic
// //     } else {
// //       setTaxiFareRows((prev) => ({ ...prev, [index]: false }));
// //     }

// //     const filter = value.toLowerCase();
// //     setFilteredServices(
// //       services.filter((s) => s.ServiceName.toLowerCase().includes(filter))
// //     );

// //     const selectedService = services.find(
// //       (s) => s.ServiceName.toLowerCase() === value.toLowerCase()
// //     );
// //     if (selectedService) {
// //       updated[index].HSNCODE = selectedService.HSNCODE || "";
// //       updated[index].TaxRate = selectedService.TaxRate || 0;
// //       updated[index].TaxID = selectedService.TaxID || null;

// //       const amt = parseFloat(updated[index].amount) || 0;
// //       updated[index].TaxAmount = (amt * updated[index].TaxRate) / 100;

// //       if (index === updated.length - 1) {
// //         updated.push({
// //           date: "",
// //           service: "",
// //           Particulars: "",
// //           quantity: "",
// //           unit: "",
// //           rate: 0,
// //           amount: 0,
// //           HSNCODE: "",
// //           TaxRate: 0,
// //           TaxID: null,
// //           TaxAmount: 0,
// //         });
// //       }
// //       setInvoice({ ...invoice, details: updated });
// //       setFilteredServices(services);
// //     }
// //   };

// //   // STEP 1: fetch duty slip + its fare package list
// // // STEP 1: fetch duty slip + its fare package list
// // const handleDutySlipIdSubmit = async (index, dutySlipId) => {
// //   if (!dutySlipId) return;

// //   try {
// //     // 1. Fetch duty slip totals
// //     const slipRes = await axios.get(`${BASE_API_URL}/dutyslip/get/${dutySlipId}`);
// //     if (!slipRes.data?.success) {
// //       toast.error("Duty Slip not found!");
// //       return;
// //     }
// //     const slip = slipRes.data.data;
// //     // slip = { totalKm, totalTime, vehicleType, dutyslipDate, CompID }

// //     // 2. Fetch ALL fare packages for this vehicle type
// //     const listRes = await axios.get(
// //       `${BASE_API_URL}/dutyslip/fares/list/${encodeURIComponent(slip.vehicleType)}?CompID=${CompID}`
// //     );

// //     const packages = listRes.data?.success ? listRes.data.data : [];

// //     if (!packages.length) {
// //       toast.error("No fare package found for this vehicle type!");
// //       return;
// //     }

// //     if (packages.length === 1) {
// //       // Only one package — use it directly
// //       await applyFareToRow(index, slip, packages[0], dutySlipId);
// //     } else {
// //       // Multiple packages — store them and let the user pick
// //       setPendingSlipByRow((prev) => ({ ...prev, [index]: { slip, dutySlipId } }));
// //       setFarePackagesByRow((prev) => ({ ...prev, [index]: packages }));
// //       toast.info("Multiple fare packages found — please select one below.");
// //     }
// //   } catch (err) {
// //     console.error("Duty Slip Fare Error:", err);
// //     toast.error(err.response?.data?.message || "Failed to fetch duty slip details!");
// //   }
// // };

// // // STEP 2: called once a package is chosen (either automatically or by the user)
// // const applyFareToRow = async (index, slip, fare, dutySlipId) => {
// //   // Run the fare formula
// //   const totalMinutes = (Number(slip.totalTime) || 0) * 60;
// //   const includedMinutes = (Number(fare.IncludedHrs) || 0) * 60;

// //   const extraKM = Math.max(0, (Number(slip.totalKm) || 0) - (Number(fare.IncludedKM) || 0));
// //   const extraMinutes = Math.max(0, totalMinutes - includedMinutes);

// //   const kmCharge = extraKM * ((Number(fare.FuelRateKM) || 0) + (Number(fare.LubRateKM) || 0));
// //   const timeCharge = extraMinutes * (Number(fare.TimeRatePM) || 0);
// //   const fareAmount = (Number(fare.BaseFare) || 0) + kmCharge + timeCharge;

// //   const formattedDate = updatedDate(slip.dutyslipDate);

// //   const updated = [...invoice.details];
// //   updated[index] = {
// //     ...updated[index],
// //     date: formattedDate || updated[index].date,
// //     service: "Taxi Fare",
// //     Particulars: `${fare.PackageName || "Taxi Fare"} - Duty Slip #${dutySlipId}`,
// //     quantity: 1,
// //     unit: "trip",
// //     rate: Math.round(fareAmount * 100) / 100,
// //     amount: Math.round(fareAmount * 100) / 100,
// //     HSNCODE: fare.HSNCODE || "",
// //     TaxRate: fare.TaxRate || 0,
// //     TaxID: fare.TaxID || null,
// //     TaxAmount: Math.round(((fareAmount * (fare.TaxRate || 0)) / 100) * 100) / 100,
// //   };

// //   if (index === updated.length - 1) {
// //     updated.push({
// //       date: "",
// //       service: "",
// //       Particulars: "",
// //       quantity: "",
// //       unit: "",
// //       rate: 0,
// //       amount: 0,
// //       HSNCODE: "",
// //       TaxRate: 0,
// //       TaxID: null,
// //       TaxAmount: 0,
// //     });
// //   }

// //   setInvoice({ ...invoice, details: updated });
// //   setTaxiFareRows((prev) => ({ ...prev, [index]: false }));
// //   setFarePackagesByRow((prev) => ({ ...prev, [index]: [] }));
// //   setPendingSlipByRow((prev) => ({ ...prev, [index]: null }));
// //   setSelectedFareIdByRow((prev) => ({ ...prev, [index]: "" }));

// //   toast.success(`Fare calculated: ₹${fareAmount.toFixed(2)}`);
// // };

// // // STEP 3: called when the user picks a package from the dropdown
// // const handleFarePackageSelect = async (index, fareId) => {
// //   setSelectedFareIdByRow((prev) => ({ ...prev, [index]: fareId }));

// //   const pending = pendingSlipByRow[index];
// //   const packages = farePackagesByRow[index] || [];
// //   const chosenFare = packages.find((p) => String(p.ID) === String(fareId));

// //   if (!pending || !chosenFare) return;

// //   await applyFareToRow(index, pending.slip, chosenFare, pending.dutySlipId);
// // };

// // const updatedDate = (dStr) => {
// //   if (!dStr) return "";
// //   try {
// //     return new Date(dStr).toISOString().split("T")[0];
// //   } catch {
// //     return dStr;
// //   }
// // };

// //   const saveInvoice = async () => {
// //     try {
// //       const payload = {
// //       ...invoice,
// //         details: invoice.details.filter((d) => d.date && d.date.trim() !== ""),
// //       };
// //       // const res = await axios.put(
// //       //   // `http://localhost:5000/api/invoice/update/${CompID}/${InvoiceNo}`,
// //       //   `${BASE_API_URL}invoice/update/${CompID}/${InvoiceNo}`,
// //       //   payload
// //       // );

// //        const res = await apiWithLog({
// //         method: "PUT",
// //         url: `${BASE_API_URL}invoice/update/${CompID}/${InvoiceNo}`,
// //         data: payload,
// //         module: "Billsinvoice",
// //         action: "E",
// //       });

// //       if (res.data.success) toast.success("Invoice updated successfully!");
// //       else toast.error("Failed to update invoice!");
// //     } catch (err) {
// //       console.error(err);
// //       toast.error("Error saving invoice!");
// //     }
// //   };

// //   if (loading) return <div>Loading...</div>;
// //   if (!invoice) return <h3>No invoice found!</h3>;

// //   return (
// //     <div className="Payment_div invoice-page">
// //       <ToastContainer position="top-right" autoClose={3000} />
// //       <h6
// //         style={{
// //           margin: 0,
// //           textAlign: "center",
// //           flexGrow: 1,
// //           fontWeight: "bold",
// //         }}
// //       >
// //         Invoice Details
// //       </h6>
// //       <div style={{ position: "absolute", right: 10, top: 10 }}>
// //         {/* <button className="save-btn" onClick={saveInvoice}>
// //           💾 Save
// //         </button> */}
// //         <button
// //           className="save-btn"
// //           onClick={() => navigate(-1)}
// //           style={{ marginLeft: "10px" }}
// //         >
// //           🔙 Back
// //         </button>
// //       </div>
// //       <br />

// //       {/* Invoice Form */}
// //       <div className="invoice-form">
// //         <div className="form-grid">
// //           {/* LEFT COLUMN */}
// //           <div className="form-column">
// //             <div className="form-row">
// //               <label>Invoice No</label>
// //               <input
// //                 type="text"
// //                 value={invoice.InvoiceNo || ""}
// //                 onChange={(e) => handleInputChange("InvoiceNo", e.target.value)}
// //                 style={{
// //                   width: "160px",
// //                   flex: "0 0 auto",
// //                 }}
// //               />
// //             </div>
// //             <div className="form-row">
// //               <label>Invoice Date</label>
// //               <DatePicker
// //                 selected={new Date(invoice.InvoiceDate)}
// //                 onChange={(date) =>
// //                   handleInputChange(
// //                     "InvoiceDate",
// //                     date ? date.toISOString().split("T")[0] : ""
// //                   )
// //                 }
// //                 dateFormat="yyyy-MM-dd"
// //               />
// //             </div>
// //             <div className="form-row">
// //               <label>Party Name</label>
// //               <select
// //                 value={invoice.PartyName || ""}
// //                 onChange={handlePartySelect}
// //               >
// //                 <option value="">Select Party</option>
// //                 {parties.map((p, i) => (
// //                   <option key={i} value={p.HEADName}>
// //                     {p.HEADName}
// //                   </option>
// //                 ))}
// //               </select>
// //             </div>
// //             <div className="form-row">
// //               <label>Address</label>
// //               <textarea
// //                 rows="2"
// //                 value={invoice.Address || ""}
// //                 onChange={(e) => handleInputChange("Address", e.target.value)}
// //               />
// //             </div>
// //             <div className="state-row">
// //               <div className="form-row">
// //                 <label>State</label>
// //                 <input
// //                   type="text"
// //                   value={invoice.State || ""}
// //                   onChange={(e) => handleInputChange("State", e.target.value)}
// //                 />
// //               </div>
// //               <div className="form-row">
// //                 <label>State Code</label>
// //                 <input
// //                   type="text"
// //                   value={invoice.StateCode || ""}
// //                   onChange={(e) =>
// //                     handleInputChange("StateCode", e.target.value)
// //                   }
// //                 />
// //               </div>
// //             </div>
// //             <div className="form-row">
// //               <label>GSTIN</label>
// //               <input
// //                 type="text"
// //                 value={invoice.GSTIN || ""}
// //                 onChange={(e) => handleInputChange("GSTIN", e.target.value)}
// //               />
// //             </div>
// //           </div>

// //           {/* RIGHT COLUMN */}
// //           <div className="form-column">
// //             <div className="form-row">
// //               <label>Reverse Charge</label>
// //               <select
// //                 value={invoice.ReverseCharges ? "Yes" : "No"}
// //                 onChange={(e) =>
// //                   handleInputChange("ReverseCharges", e.target.value === "Yes")
// //                 }
// //                 style={{
// //                   width: "130px",
// //                   flex: "0 0 auto",
// //                 }}
// //               >
// //                 <option>No</option>
// //                 <option>Yes</option>
// //               </select>
// //             </div>

// //             <div className="form-row">
// //               <label>Duty Slip No</label>
// //               <input
// //                 type="text"
// //                 value={invoice.DutySlipNo || ""}
// //                 onChange={(e) =>
// //                   handleInputChange("DutySlipNo", e.target.value)
// //                 }
// //                 style={{
// //                   width: "130px",
// //                   flex: "0 0 auto",
// //                 }}
// //               />
// //             </div>

// //             <div className="form-row">
// //               <label>Vehicle No</label>
// //               <select
// //                 value={invoice.VehicleNo || ""}
// //                 onChange={handleVehicleSelect}
// //                 style={{
// //                   width: "130px",
// //                   flex: "0 0 auto",
// //                 }}
// //               >
// //                 <option value="">Select Vehicle</option>
// //                 {vehicles.map((v, i) => (
// //                   <option key={i} value={v.VehicleNo}>
// //                     {v.VehicleNo}
// //                   </option>
// //                 ))}
// //               </select>
// //             </div>

// //             <div className="form-row">
// //               <label>Vehicle Type</label>
// //               <input
// //                 type="text"
// //                 value={invoice.VehicleType || ""}
// //                 readOnly
// //                 style={{
// //                   width: "130px",
// //                   backgroundColor: "#f3f3f3",
// //                   flex: "0 0 auto",
// //                 }}
// //               />
// //             </div>

// //             <div className="form-row">
// //               <label>Guest</label>
// //               <input
// //                 type="text"
// //                 value={invoice.Guest || ""}
// //                 onChange={(e) => handleInputChange("Guest", e.target.value)}
// //                 style={{
// //                   width: "250px",
// //                   flex: "0 0 auto",
// //                 }}
// //               />
// //             </div>

// //             <div className="form-row">
// //               <label>Booked By</label>
// //               <input
// //                 type="text"
// //                 value={invoice.BookedBy || ""}
// //                 onChange={(e) => handleInputChange("BookedBy", e.target.value)}
// //                 style={{
// //                   width: "250px",
// //                   flex: "0 0 auto",
// //                 }}
// //               />
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* SERVICE DETAILS TABLE */}
// //       <div className="invoice-preview">
// //         <table className="invoice-table">
// //           <thead>
// //             <tr>
// //               <th>Date</th>
// //               <th>Service</th>
// //               <th>Particulars</th>
// //               <th>Qty</th>
// //               <th>Units</th>
// //               <th>Rate</th>
// //               <th>Amount</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {invoice.details.length === 0 && (
// //               <tr>
// //                 <td colSpan="7" style={{ textAlign: "center" }}>
// //                   No items found
// //                 </td>
// //               </tr>
// //             )}
// //             {invoice.details.map((item, index) => (
// //               <tr key={index}>
// //                 <td>
// //                   <DatePicker
// //                     selected={item.date ? new Date(item.date) : null}
// //                     onChange={(date) =>
// //                       handleDetailChange(
// //                         index,
// //                         "date",
// //                         date ? date.toISOString().split("T")[0] : ""
// //                       )
// //                     }
// //                     dateFormat="yyyy-MM-dd"
// //                     placeholderText="Select date"
// //                     isClearable
// //                   />
// //                 </td>
// //                 <td className="service-cell">
// //                   <div className="service-dropdown-wrapper">
// //                     <input
// //                       type="text"
// //                       value={item.service}
// //                       onChange={(e) =>
// //                         handleServiceChange(index, e.target.value)
// //                       }
// //                       onFocus={() => setActiveServiceRow(index)}
// //                       onBlur={() =>
// //                         setTimeout(() => setActiveServiceRow(null), 150)
// //                       }
// //                       placeholder="Select or type..."
// //                     />
// //                     {activeServiceRow === index && (
// //                       <ul className="service-dropdown-list">
// //                         <li onMouseDown={() => handleServiceChange(index, "Taxi Fare")}>
// //                           🚕 Taxi Fare (from Duty Slip)
// //                         </li>
// //                         {filteredServices.map((s, i) => (
// //                           <li
// //                             key={i}
// //                             onMouseDown={() =>
// //                               handleServiceChange(index, s.ServiceName)
// //                             }
// //                           >
// //                             {s.ServiceName}
// //                           </li>
// //                         ))}
// //                       </ul>
// //                     )}
// //                   </div>

// //                   {/* Extra box shown only when Taxi Fare is selected */}
// //                   {taxiFareRows[index] && (
// //                     <input
// //                       type="text"
// //                       className="duty-slip-input"
// //                       placeholder="Enter Duty Slip ID & press Enter"
// //                       value={dutySlipIdInput[index] || ""}
// //                       onChange={(e) =>
// //                         setDutySlipIdInput((prev) => ({ ...prev, [index]: e.target.value }))
// //                       }
// //                       onKeyDown={(e) => {
// //                         if (e.key === "Enter") {
// //                           handleDutySlipIdSubmit(index, dutySlipIdInput[index]);
// //                         }
// //                       }}
// //                       style={{ marginTop: "4px", fontSize: "12px", width: "100%", padding: "4px 8px" }}
// //                     />
// //                   )}

// //                   {/* NEW: Package picker — shows only if multiple fare packages were found */}
// //                   {farePackagesByRow[index]?.length > 1 && (
// //                     <select
// //                       value={selectedFareIdByRow[index] || ""}
// //                       onChange={(e) => handleFarePackageSelect(index, e.target.value)}
// //                       style={{ marginTop: "4px", fontSize: "12px", width: "100%", padding: "4px 8px" }}
// //                     >
// //                       <option value="">Select fare package...</option>
// //                       {farePackagesByRow[index].map((pkg) => (
// //                         <option key={pkg.ID} value={pkg.ID}>
// //                           {pkg.PackageName} (Base ₹{pkg.BaseFare})
// //                         </option>
// //                       ))}
// //                     </select>
// //                   )}
// //                 </td>
// //                 <td>
// //                   <input
// //                     type="text"
// //                     value={item.Particulars || ""}
// //                     onChange={(e) =>
// //                       handleDetailChange(index, "Particulars", e.target.value)
// //                     }
// //                   />
// //                 </td>
// //                 <td>
// //                   <input
// //                     type="number"
// //                     value={item.quantity || ""}
// //                     onChange={(e) =>
// //                       handleDetailChange(index, "quantity", e.target.value)
// //                     }
// //                   />
// //                 </td>
// //                 <td>
// //                   <input
// //                     type="text"
// //                     value={item.unit || ""}
// //                     onChange={(e) =>
// //                       handleDetailChange(index, "unit", e.target.value)
// //                     }
// //                   />
// //                 </td>
// //                 <td>
// //                   <input
// //                     type="number"
// //                     value={item.rate || ""}
// //                     onChange={(e) =>
// //                       handleDetailChange(index, "rate", e.target.value)
// //                     }
// //                   />
// //                 </td>
// //                 <td>{item.amount?.toFixed(2)}</td>
// //               </tr>
// //             ))}
// //           </tbody>
// //           <tfoot>
// //             <tr>
// //               <td colSpan="6" style={{ textAlign: "right" }}>
// //                 <strong>Total Taxable Amount:</strong>
// //               </td>
// //               <td>₹{totalAmount.toFixed(2)}</td>
// //             </tr>
// //             <tr>
// //               <td colSpan="6" style={{ textAlign: "right" }}>
// //                 <strong>Tax Amount:</strong>
// //               </td>
// //               <td>₹{taxTotal.toFixed(2)}</td>
// //             </tr>
// //             <tr>
// //               <td colSpan="6" style={{ textAlign: "right" }}>
// //                 <strong>Grand Total:</strong>
// //               </td>
// //               <td>₹{grandTotal.toFixed(2)}</td>
// //             </tr>
// //           </tfoot>
// //         </table>

// //         {/* HSN SUMMARY TABLE */}
// //         {/* <div style={{ marginTop: 40 }}>
// //           <table
// //             className="invoice-table"
// //             style={{
// //               width: "60%",
// //               marginTop: 8,
// //               fontSize: "13px",
// //               borderCollapse: "collapse",
// //             }}
// //           >
// //             <thead>
// //               <tr>
// //                 <th style={{ width: "18%", padding: "6px" }}>HSN Code</th>
// //                 <th style={{ width: "18%", padding: "6px" }}>Tax Rate (%)</th>
// //                 <th style={{ width: "18%", padding: "6px" }}>Taxable Amount</th>
// //                 <th style={{ width: "18%", padding: "6px" }}>Tax</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {hsnSummary.length === 0 && (
// //                 <tr>
// //                   <td colSpan="4" style={{ textAlign: "center" }}>
// //                     No HSN data
// //                   </td>
// //                 </tr>
// //               )}
// //               {hsnSummary.map((h, i) => (
// //                 <tr key={i}>
// //                   <td style={{ padding: "4px" }}>{h.HSNCODE}</td>
// //                   <td style={{ padding: "4px" }}>
// //                     {Number(h.TaxRate).toFixed(2)}%
// //                   </td>
// //                   <td style={{ padding: "4px", textAlign: "right" }}>
// //                     {Number(h.taxableAmount).toFixed(2)}
// //                   </td>
// //                   <td style={{ padding: "4px", textAlign: "right" }}>
// //                     {Number(h.totalTax).toFixed(2)}
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //             <tfoot>
// //               <tr>
// //                 <td colSpan="3" style={{ textAlign: "right" }}>
// //                   <strong>Tax Total:</strong>
// //                 </td>
// //                 <td style={{ textAlign: "right" }}>{taxTotal.toFixed(2)}</td>
// //               </tr>
// //             </tfoot>
// //           </table>
// //         </div> */}
// //       </div>
// //     </div>
// //   );
// // };

// // export default InvoiceDetails;
// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import DatePicker from "react-datepicker";
// import "react-toastify/dist/ReactToastify.css";
// import "react-datepicker/dist/react-datepicker.css";
// import "./Invoice.css";
// import "./InvoiceDetails.css";
// import { apiWithLog } from "../utils/apiWithLog";

// const InvoiceDetails = () => {
//   const { CompID, InvoiceNo } = useParams();
//   const navigate = useNavigate();

//   const [invoice, setInvoice] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [parties, setParties] = useState([]);
//   const [vehicles, setVehicles] = useState([]);
//   const [services, setServices] = useState([]);
//   const [filteredServices, setFilteredServices] = useState([]);
//   const [activeServiceRow, setActiveServiceRow] = useState(null);
//   const [hsnSummary, setHsnSummary] = useState([]);

//   // ── NEW STATE: track which rows are in "Taxi Fare" mode ──
//   const [taxiFareRows, setTaxiFareRows] = useState({}); // { rowIndex: true/false }
//   const [dutySlipIdInput, setDutySlipIdInput] = useState({}); // { rowIndex: "123" }

//   // NEW: fare package selection per row
//   const [farePackagesByRow, setFarePackagesByRow] = useState({}); // { rowIndex: [pkg, pkg...] }
//   const [selectedFareIdByRow, setSelectedFareIdByRow] = useState({}); // { rowIndex: fareId }
//   const [pendingSlipByRow, setPendingSlipByRow] = useState({}); // { rowIndex: slipData } — holds slip until package chosen

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           `${BASE_API_URL}/invoice/details/${CompID}/${InvoiceNo}`
//         );

//         if (response.data.success && response.data.data) {
//           const data = response.data.data;

//           // Flatten items from hsnSummary
//           const details = data.items
//   ? data.items.map((item) => ({
//       date: item.date || "",
//       service: item.service || "",
//       Particulars: item.particulars || "",
//       quantity: item.quantity || "",
//       unit: item.unit || "",
//       rate: item.rate || 0,
//       amount: item.amount || 0,
//       HSNCODE: item.HSNCODE || "",
//       TaxRate: item.TaxRate || 0,
//       TaxID: item.TaxID || null,
//       TaxAmount: item.TaxAmount || 0,
//     }))
//   : [];
//           setInvoice({
//             ...data,
//             details:
//               details.length > 0
//                 ? details
//                 : [
//                     {
//                       date: "",
//                       service: "",
//                       Particulars: "",
//                       quantity: "",
//                       unit: "",
//                       rate: 0,
//                       amount: 0,
//                       HSNCODE: "",
//                       TaxRate: 0,
//                       TaxID: null,
//                       TaxAmount: 0,
//                     },
//                   ],
//           });

//           setHsnSummary(data.hsnSummary || []);
//         } else toast.error("Invoice not found!");

//         // Fetch dropdowns
//         const [partyRes, vehicleRes, serviceRes] = await Promise.all([
//           axios.get(`${BASE_API_URL}/invoice/dropdowns/${CompID}`),
//           axios.get(`${BASE_API_URL}/invoice/vehicles/${CompID}`),
//           axios.get(`${BASE_API_URL}/invoice/services/${CompID}`),
//         ]);

//         if (partyRes.data.success) setParties(partyRes.data.data);
//         if (vehicleRes.data.success) setVehicles(vehicleRes.data.data);
//         if (serviceRes.data.success) {
//           setServices(serviceRes.data.data);
//           setFilteredServices(serviceRes.data.data);
//         }
//       } catch (error) {
//         console.error("❌ Error:", error);
//         toast.error("Failed to fetch invoice details!");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [CompID, InvoiceNo]);

//   // Totals
//   const totalAmount = invoice ? invoice.totalAmount || 0 : 0;
//   const taxTotal = invoice ? invoice.totalTax || 0 : 0;
//   const grandTotal = invoice ? invoice.grandTotal || 0 : 0;

//   // ===== Handlers =====

//   // Generic input change handler
//   const handleInputChange = (field, value) => {
//     setInvoice({ ...invoice, [field]: value });
//   };

//   // Party select
//   const handlePartySelect = (e) => {
//     const value = e.target.value;
//     setInvoice({ ...invoice, PartyName: value });
//   };

//   // Vehicle select
//   const handleVehicleSelect = (e) => {
//     const value = e.target.value;
//     const selectedVehicle = vehicles.find((v) => v.VehicleNo === value);
//     setInvoice({
//       ...invoice,
//       VehicleNo: value,
//       VehicleType: selectedVehicle ? selectedVehicle.VehicleType : "",
//     });
//   };

//   // Service table change
//   const handleDetailChange = (index, field, value) => {
//     const updated = [...invoice.details];
//     updated[index][field] = value;

//     if (field === "quantity" || field === "rate") {
//       const qty = parseFloat(updated[index].quantity) || 0;
//       const rate = parseFloat(updated[index].rate) || 0;
//       updated[index].amount = qty * rate;
//       updated[index].TaxAmount =
//         (updated[index].amount * (parseFloat(updated[index].TaxRate) || 0)) /
//         100;
//     }

//     setInvoice({ ...invoice, details: updated });
//   };

//   const handleServiceChange = (index, value) => {
//     const updated = [...invoice.details];
//     updated[index].service = value;
//     setActiveServiceRow(index);

//     // Special case: Taxi Fare selected
//     if (value === "Taxi Fare") {
//       setTaxiFareRows((prev) => ({ ...prev, [index]: true }));
//       setInvoice({ ...invoice, details: updated });
//       setActiveServiceRow(null); // close dropdown
//       return; // don't run normal service-matching logic
//     } else {
//       setTaxiFareRows((prev) => ({ ...prev, [index]: false }));
//     }

//     const filter = value.toLowerCase();
//     setFilteredServices(
//       services.filter((s) => s.ServiceName.toLowerCase().includes(filter))
//     );

//     const selectedService = services.find(
//       (s) => s.ServiceName.toLowerCase() === value.toLowerCase()
//     );
//     if (selectedService) {
//       updated[index].HSNCODE = selectedService.HSNCODE || "";
//       updated[index].TaxRate = selectedService.TaxRate || 0;
//       updated[index].TaxID = selectedService.TaxID || null;

//       const amt = parseFloat(updated[index].amount) || 0;
//       updated[index].TaxAmount = (amt * updated[index].TaxRate) / 100;

//       if (index === updated.length - 1) {
//         updated.push({
//           date: "",
//           service: "",
//           Particulars: "",
//           quantity: "",
//           unit: "",
//           rate: 0,
//           amount: 0,
//           HSNCODE: "",
//           TaxRate: 0,
//           TaxID: null,
//           TaxAmount: 0,
//         });
//       }
//       setInvoice({ ...invoice, details: updated });
//       setFilteredServices(services);
//     }
//   };

//   // STEP 1: fetch duty slip + its fare package list
//   const handleDutySlipIdSubmit = async (index, dutySlipId) => {
//     if (!dutySlipId) return;

//     try {
//       // 1. Fetch duty slip totals
//       const slipRes = await axios.get(`${BASE_API_URL}/dutyslip/get/${dutySlipId}`);
//       if (!slipRes.data?.success) {
//         toast.error("Duty Slip not found!");
//         return;
//       }
//       const slip = slipRes.data.data;
//       // slip = { totalKm, totalTime, vehicleType, dutyslipDate, CompID }

//       // 2. Fetch ALL fare packages for this vehicle type
//       const listRes = await axios.get(
//         `${BASE_API_URL}/dutyslip/fares/list/${encodeURIComponent(slip.vehicleType)}?CompID=${CompID}`
//       );

//       const packages = listRes.data?.success ? listRes.data.data : [];

//       if (!packages.length) {
//         toast.error("No fare package found for this vehicle type!");
//         return;
//       }

//       if (packages.length === 1) {
//         // Only one package — use it directly
//         await applyFareToRow(index, slip, packages[0], dutySlipId);
//       } else {
//         // Multiple packages — store them and let the user pick
//         setPendingSlipByRow((prev) => ({ ...prev, [index]: { slip, dutySlipId } }));
//         setFarePackagesByRow((prev) => ({ ...prev, [index]: packages }));
//         toast.info("Multiple fare packages found — please select one below.");
//       }
//     } catch (err) {
//       console.error("Duty Slip Fare Error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch duty slip details!");
//     }
//   };

//   // STEP 2: called once a package is chosen (either automatically or by the user)
//   const applyFareToRow = async (index, slip, fare, dutySlipId) => {
//     // Run the fare formula
//     const totalMinutes = (Number(slip.totalTime) || 0) * 60;
//     const includedMinutes = (Number(fare.IncludedHrs) || 0) * 60;

//     const extraKM = Math.max(0, (Number(slip.totalKm) || 0) - (Number(fare.IncludedKM) || 0));
//     const extraMinutes = Math.max(0, totalMinutes - includedMinutes);

//     const kmCharge = extraKM * ((Number(fare.FuelRateKM) || 0) + (Number(fare.LubRateKM) || 0));
//     const timeCharge = extraMinutes * (Number(fare.TimeRatePM) || 0);
//     const fareAmount = (Number(fare.BaseFare) || 0) + kmCharge + timeCharge;

//     const formattedDate = updatedDate(slip.dutyslipDate);

//     const updated = [...invoice.details];
//     updated[index] = {
//       ...updated[index],
//       date: formattedDate || updated[index].date,
//       service: "Taxi Fare",
//       Particulars: `${fare.PackageName || "Taxi Fare"} - Duty Slip #${dutySlipId}`,
//       quantity: 1,
//       unit: "trip",
//       rate: Math.round(fareAmount * 100) / 100,
//       amount: Math.round(fareAmount * 100) / 100,
//       HSNCODE: fare.HSNCODE || "",
//       TaxRate: fare.TaxRate || 0,
//       TaxID: fare.TaxID || null,
//       TaxAmount: Math.round(((fareAmount * (fare.TaxRate || 0)) / 100) * 100) / 100,
//     };

//     if (index === updated.length - 1) {
//       updated.push({
//         date: "",
//         service: "",
//         Particulars: "",
//         quantity: "",
//         unit: "",
//         rate: 0,
//         amount: 0,
//         HSNCODE: "",
//         TaxRate: 0,
//         TaxID: null,
//         TaxAmount: 0,
//       });
//     }

//     setInvoice({ ...invoice, details: updated });
//     setTaxiFareRows((prev) => ({ ...prev, [index]: false }));
//     setFarePackagesByRow((prev) => ({ ...prev, [index]: [] }));
//     setPendingSlipByRow((prev) => ({ ...prev, [index]: null }));
//     setSelectedFareIdByRow((prev) => ({ ...prev, [index]: "" }));

//     toast.success(`Fare calculated: ₹${fareAmount.toFixed(2)}`);
//   };

//   // STEP 3: called when the user picks a package from the dropdown
//   const handleFarePackageSelect = async (index, fareId) => {
//     setSelectedFareIdByRow((prev) => ({ ...prev, [index]: fareId }));

//     const pending = pendingSlipByRow[index];
//     const packages = farePackagesByRow[index] || [];
//     const chosenFare = packages.find((p) => String(p.ID) === String(fareId));

//     if (!pending || !chosenFare) return;

//     await applyFareToRow(index, pending.slip, chosenFare, pending.dutySlipId);
//   };

//   const updatedDate = (dStr) => {
//     if (!dStr) return "";
//     try {
//       return new Date(dStr).toISOString().split("T")[0];
//     } catch {
//       return dStr;
//     }
//   };

//   // ====== FIXED SAVE FUNCTION ======
//   const saveInvoice = async () => {
//     try {
//       // Build payload with properly mapped detail fields
//       const payload = {
//         ...invoice,
//         details: invoice.details
//           .filter((d) => d.date && d.date.trim() !== "") // only keep non‑empty rows
//           .map((d) => ({
//             Date: d.date,
//             Qty: d.quantity,
//             Rate: d.rate,
//             Amount: d.amount,
//             Units: d.unit,
//             Services: d.service,
//             Particulars: d.Particulars,
//             TaxID: d.TaxID,
//             TaxRate: d.TaxRate,
//             HSNCODE: d.HSNCODE,   // ← required for backend to store HSN
//           })),
//       };

//       const res = await apiWithLog({
//         method: "PUT",
//         url: `${BASE_API_URL}invoice/update/${CompID}/${InvoiceNo}`,
//         data: payload,
//         module: "Billsinvoice",
//         action: "E",
//       });

//       if (res.data.success) toast.success("Invoice updated successfully!");
//       else toast.error("Failed to update invoice!");
//     } catch (err) {
//       console.error(err);
//       toast.error("Error saving invoice!");
//     }
//   };

//   if (loading) return <div>Loading...</div>;
//   if (!invoice) return <h3>No invoice found!</h3>;

//   return (
//     <div className="Payment_div invoice-page">
//       <ToastContainer position="top-right" autoClose={3000} />
//       <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
//         <h6 style={{ margin: 0, textAlign: "center", flexGrow: 1, fontWeight: "bold" }}>
//           Invoice Details
//         </h6>
//         <div style={{ position: "absolute", right: 10, top: 0 }}>
//           {/* ✅ Save button uncommented and fixed */}
//           <button className="save-btn" onClick={saveInvoice}>
//             💾 Save
//           </button>
//           <button
//             className="save-btn"
//             onClick={() => navigate(-1)}
//             style={{ marginLeft: "10px" }}
//           >
//             🔙 Back
//           </button>
//         </div>
//       </div>
//       <br />

//       {/* Invoice Form */}
//       <div className="invoice-form">
//         <div className="form-grid">
//           {/* LEFT COLUMN */}
//           <div className="form-column">
//             <div className="form-row">
//               <label>Invoice No</label>
//               <input
//                 type="text"
//                 value={invoice.InvoiceNo || ""}
//                 onChange={(e) => handleInputChange("InvoiceNo", e.target.value)}
//                 style={{
//                   width: "160px",
//                   flex: "0 0 auto",
//                 }}
//               />
//             </div>
//             <div className="form-row">
//               <label>Invoice Date</label>
//               <DatePicker
//                 selected={new Date(invoice.InvoiceDate)}
//                 onChange={(date) =>
//                   handleInputChange(
//                     "InvoiceDate",
//                     date ? date.toISOString().split("T")[0] : ""
//                   )
//                 }
//                 dateFormat="yyyy-MM-dd"
//               />
//             </div>
//             <div className="form-row">
//               <label>Party Name</label>
//               <select
//                 value={invoice.PartyName || ""}
//                 onChange={handlePartySelect}
//               >
//                 <option value="">Select Party</option>
//                 {parties.map((p, i) => (
//                   <option key={i} value={p.HEADName}>
//                     {p.HEADName}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-row">
//               <label>Address</label>
//               <textarea
//                 rows="2"
//                 value={invoice.Address || ""}
//                 onChange={(e) => handleInputChange("Address", e.target.value)}
//               />
//             </div>
//             <div className="state-row">
//               <div className="form-row">
//                 <label>State</label>
//                 <input
//                   type="text"
//                   value={invoice.State || ""}
//                   onChange={(e) => handleInputChange("State", e.target.value)}
//                 />
//               </div>
//               <div className="form-row">
//                 <label>State Code</label>
//                 <input
//                   type="text"
//                   value={invoice.StateCode || ""}
//                   onChange={(e) =>
//                     handleInputChange("StateCode", e.target.value)
//                   }
//                 />
//               </div>
//             </div>
//             <div className="form-row">
//               <label>GSTIN</label>
//               <input
//                 type="text"
//                 value={invoice.GSTIN || ""}
//                 onChange={(e) => handleInputChange("GSTIN", e.target.value)}
//               />
//             </div>
//           </div>

//           {/* RIGHT COLUMN */}
//           <div className="form-column">
//             <div className="form-row">
//               <label>Reverse Charge</label>
//               <select
//                 value={invoice.ReverseCharges ? "Yes" : "No"}
//                 onChange={(e) =>
//                   handleInputChange("ReverseCharges", e.target.value === "Yes")
//                 }
//                 style={{
//                   width: "130px",
//                   flex: "0 0 auto",
//                 }}
//               >
//                 <option>No</option>
//                 <option>Yes</option>
//               </select>
//             </div>

//             <div className="form-row">
//               <label>Duty Slip No</label>
//               <input
//                 type="text"
//                 value={invoice.DutySlipNo || ""}
//                 onChange={(e) =>
//                   handleInputChange("DutySlipNo", e.target.value)
//                 }
//                 style={{
//                   width: "130px",
//                   flex: "0 0 auto",
//                 }}
//               />
//             </div>

//             <div className="form-row">
//               <label>Vehicle No</label>
//               <select
//                 value={invoice.VehicleNo || ""}
//                 onChange={handleVehicleSelect}
//                 style={{
//                   width: "130px",
//                   flex: "0 0 auto",
//                 }}
//               >
//                 <option value="">Select Vehicle</option>
//                 {vehicles.map((v, i) => (
//                   <option key={i} value={v.VehicleNo}>
//                     {v.VehicleNo}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="form-row">
//               <label>Vehicle Type</label>
//               <input
//                 type="text"
//                 value={invoice.VehicleType || ""}
//                 readOnly
//                 style={{
//                   width: "130px",
//                   backgroundColor: "#f3f3f3",
//                   flex: "0 0 auto",
//                 }}
//               />
//             </div>

//             <div className="form-row">
//               <label>Guest</label>
//               <input
//                 type="text"
//                 value={invoice.Guest || ""}
//                 onChange={(e) => handleInputChange("Guest", e.target.value)}
//                 style={{
//                   width: "250px",
//                   flex: "0 0 auto",
//                 }}
//               />
//             </div>

//             <div className="form-row">
//               <label>Booked By</label>
//               <input
//                 type="text"
//                 value={invoice.BookedBy || ""}
//                 onChange={(e) => handleInputChange("BookedBy", e.target.value)}
//                 style={{
//                   width: "250px",
//                   flex: "0 0 auto",
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* SERVICE DETAILS TABLE */}
//       <div className="invoice-preview">
//         <table className="invoice-table">
//           <thead>
//             <tr>
//               <th>Date</th>
//               <th>Service</th>
//               <th>Particulars</th>
//               <th>Qty</th>
//               <th>Units</th>
//               <th>Rate</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {invoice.details.length === 0 && (
//               <tr>
//                 <td colSpan="7" style={{ textAlign: "center" }}>
//                   No items found
//                 </td>
//               </tr>
//             )}
//             {invoice.details.map((item, index) => (
//               <tr key={index}>
//                 <td>
//                   <DatePicker
//                     selected={item.date ? new Date(item.date) : null}
//                     onChange={(date) =>
//                       handleDetailChange(
//                         index,
//                         "date",
//                         date ? date.toISOString().split("T")[0] : ""
//                       )
//                     }
//                     dateFormat="yyyy-MM-dd"
//                     placeholderText="Select date"
//                     isClearable
//                   />
//                 </td>
//                 <td className="service-cell">
//                   <div className="service-dropdown-wrapper">
//                     <input
//                       type="text"
//                       value={item.service}
//                       onChange={(e) =>
//                         handleServiceChange(index, e.target.value)
//                       }
//                       onFocus={() => setActiveServiceRow(index)}
//                       onBlur={() =>
//                         setTimeout(() => setActiveServiceRow(null), 150)
//                       }
//                       placeholder="Select or type..."
//                     />
//                     {activeServiceRow === index && (
//                       <ul className="service-dropdown-list">
//                         <li onMouseDown={() => handleServiceChange(index, "Taxi Fare")}>
//                           🚕 Taxi Fare (from Duty Slip)
//                         </li>
//                         {filteredServices.map((s, i) => (
//                           <li
//                             key={i}
//                             onMouseDown={() =>
//                               handleServiceChange(index, s.ServiceName)
//                             }
//                           >
//                             {s.ServiceName}
//                           </li>
//                         ))}
//                       </ul>
//                     )}
//                   </div>

//                   {/* Extra box shown only when Taxi Fare is selected */}
//                   {taxiFareRows[index] && (
//                     <input
//                       type="text"
//                       className="duty-slip-input"
//                       placeholder="Enter Duty Slip ID & press Enter"
//                       value={dutySlipIdInput[index] || ""}
//                       onChange={(e) =>
//                         setDutySlipIdInput((prev) => ({ ...prev, [index]: e.target.value }))
//                       }
//                       onKeyDown={(e) => {
//                         if (e.key === "Enter") {
//                           handleDutySlipIdSubmit(index, dutySlipIdInput[index]);
//                         }
//                       }}
//                       style={{ marginTop: "4px", fontSize: "12px", width: "100%", padding: "4px 8px" }}
//                     />
//                   )}

//                   {/* NEW: Package picker — shows only if multiple fare packages were found */}
//                   {farePackagesByRow[index]?.length > 1 && (
//                     <select
//                       value={selectedFareIdByRow[index] || ""}
//                       onChange={(e) => handleFarePackageSelect(index, e.target.value)}
//                       style={{ marginTop: "4px", fontSize: "12px", width: "100%", padding: "4px 8px" }}
//                     >
//                       <option value="">Select fare package...</option>
//                       {farePackagesByRow[index].map((pkg) => (
//                         <option key={pkg.ID} value={pkg.ID}>
//                           {pkg.PackageName} (Base ₹{pkg.BaseFare})
//                         </option>
//                       ))}
//                     </select>
//                   )}
//                 </td>
//                 <td>
//                   <input
//                     type="text"
//                     value={item.Particulars || ""}
//                     onChange={(e) =>
//                       handleDetailChange(index, "Particulars", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td>
//                   <input
//                     type="number"
//                     value={item.quantity || ""}
//                     onChange={(e) =>
//                       handleDetailChange(index, "quantity", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td>
//                   <input
//                     type="text"
//                     value={item.unit || ""}
//                     onChange={(e) =>
//                       handleDetailChange(index, "unit", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td>
//                   <input
//                     type="number"
//                     value={item.rate || ""}
//                     onChange={(e) =>
//                       handleDetailChange(index, "rate", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td>{item.amount?.toFixed(2)}</td>
//               </tr>
//             ))}
//           </tbody>
//           <tfoot>
//             <tr>
//               <td colSpan="6" style={{ textAlign: "right" }}>
//                 <strong>Total Taxable Amount:</strong>
//               </td>
//               <td>₹{totalAmount.toFixed(2)}</td>
//             </tr>
//             <tr>
//               <td colSpan="6" style={{ textAlign: "right" }}>
//                 <strong>Tax Amount:</strong>
//               </td>
//               <td>₹{taxTotal.toFixed(2)}</td>
//             </tr>
//             <tr>
//               <td colSpan="6" style={{ textAlign: "right" }}>
//                 <strong>Grand Total:</strong>
//               </td>
//               <td>₹{grandTotal.toFixed(2)}</td>
//             </tr>
//           </tfoot>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default InvoiceDetails;

// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import DatePicker from "react-datepicker";
// import "react-toastify/dist/ReactToastify.css";
// import "react-datepicker/dist/react-datepicker.css";
// import "./Invoice.css";
// import "./InvoiceDetails.css";
// import { apiWithLog } from "../utils/apiWithLog";

// const InvoiceDetails = () => {
//   const { CompID, InvoiceNo } = useParams();
//   const navigate = useNavigate();

//   const [invoice, setInvoice] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [parties, setParties] = useState([]);
//   const [vehicles, setVehicles] = useState([]);
//   const [services, setServices] = useState([]);
//   const [filteredServices, setFilteredServices] = useState([]);
//   const [activeServiceRow, setActiveServiceRow] = useState(null);
//   const [hsnSummary, setHsnSummary] = useState([]);

//   // ── Taxi Fare mode state ──
//   const [taxiFareRows, setTaxiFareRows] = useState({});
//   const [dutySlipIdInput, setDutySlipIdInput] = useState({});
//   const [farePackagesByRow, setFarePackagesByRow] = useState({});
//   const [selectedFareIdByRow, setSelectedFareIdByRow] = useState({});
//   const [pendingSlipByRow, setPendingSlipByRow] = useState({});

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   // ── Fetch invoice data on load ──
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           `${BASE_API_URL}/invoice/details/${CompID}/${InvoiceNo}`,
//         );

//         if (response.data.success && response.data.data) {
//           const data = response.data.data;

//           // Flatten items from data.items
//           const details = data.items
//             ? data.items.map((item) => ({
//                 date: item.date || "",
//                 service: item.service || "",
//                 Particulars: item.particulars || "",
//                 quantity: item.quantity || "",
//                 unit: item.unit || "",
//                 rate: item.rate || 0,
//                 amount: item.amount || 0,
//                 HSNCODE: item.HSNCODE || "",
//                 TaxRate: item.TaxRate || 0,
//                 TaxID: item.TaxID || null,
//                 TaxAmount: item.TaxAmount || 0,
//               }))
//             : [];

//           setInvoice({
//             ...data,
//             details:
//               details.length > 0
//                 ? details
//                 : [
//                     {
//                       date: "",
//                       service: "",
//                       Particulars: "",
//                       quantity: "",
//                       unit: "",
//                       rate: 0,
//                       amount: 0,
//                       HSNCODE: "",
//                       TaxRate: 0,
//                       TaxID: null,
//                       TaxAmount: 0,
//                     },
//                   ],
//           });

//           setHsnSummary(data.hsnSummary || []);
//         } else {
//           toast.error("Invoice not found!");
//         }

//         // Fetch dropdowns
//         const [partyRes, vehicleRes, serviceRes] = await Promise.all([
//           axios.get(`${BASE_API_URL}/invoice/dropdowns/${CompID}`),
//           axios.get(`${BASE_API_URL}/invoice/vehicles/${CompID}`),
//           axios.get(`${BASE_API_URL}/invoice/services/${CompID}`),
//         ]);

//         if (partyRes.data.success) setParties(partyRes.data.data);
//         if (vehicleRes.data.success) setVehicles(vehicleRes.data.data);
//         if (serviceRes.data.success) {
//           setServices(serviceRes.data.data);
//           setFilteredServices(serviceRes.data.data);
//         }
//       } catch (error) {
//         console.error("❌ Error:", error);
//         toast.error("Failed to fetch invoice details!");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [CompID, InvoiceNo]);

//   // Totals
//   const totalAmount = invoice ? invoice.totalAmount || 0 : 0;
//   const taxTotal = invoice ? invoice.totalTax || 0 : 0;
//   const grandTotal = invoice ? invoice.grandTotal || 0 : 0;

//   // ===== Handlers =====

//   const handleInputChange = (field, value) => {
//     setInvoice({ ...invoice, [field]: value });
//   };

//   const handlePartySelect = (e) => {
//     const value = e.target.value;
//     setInvoice({ ...invoice, PartyName: value });
//   };

//   const handleVehicleSelect = (e) => {
//     const value = e.target.value;
//     const selectedVehicle = vehicles.find((v) => v.VehicleNo === value);
//     setInvoice({
//       ...invoice,
//       VehicleNo: value,
//       VehicleType: selectedVehicle ? selectedVehicle.VehicleType : "",
//     });
//   };

//   const handleDetailChange = (index, field, value) => {
//     const updated = [...invoice.details];
//     updated[index][field] = value;

//     if (field === "quantity" || field === "rate") {
//       const qty = parseFloat(updated[index].quantity) || 0;
//       const rate = parseFloat(updated[index].rate) || 0;
//       updated[index].amount = qty * rate;
//       updated[index].TaxAmount =
//         (updated[index].amount * (parseFloat(updated[index].TaxRate) || 0)) /
//         100;
//     }

//     setInvoice({ ...invoice, details: updated });
//   };

//   const handleServiceChange = (index, value) => {
//     const updated = [...invoice.details];
//     updated[index].service = value;
//     setActiveServiceRow(index);

//     // Special case: Taxi Fare selected
//     if (value === "Taxi Fare") {
//       setTaxiFareRows((prev) => ({ ...prev, [index]: true }));
//       setInvoice({ ...invoice, details: updated });
//       setActiveServiceRow(null);
//       return;
//     } else {
//       setTaxiFareRows((prev) => ({ ...prev, [index]: false }));
//     }

//     const filter = value.toLowerCase();
//     setFilteredServices(
//       services.filter((s) => s.ServiceName.toLowerCase().includes(filter)),
//     );

//     const selectedService = services.find(
//       (s) => s.ServiceName.toLowerCase() === value.toLowerCase(),
//     );
//     if (selectedService) {
//       updated[index].HSNCODE = selectedService.HSNCODE || "";
//       updated[index].TaxRate = selectedService.TaxRate || 0;
//       updated[index].TaxID = selectedService.TaxID || null;

//       const amt = parseFloat(updated[index].amount) || 0;
//       updated[index].TaxAmount = (amt * updated[index].TaxRate) / 100;

//       if (index === updated.length - 1) {
//         updated.push({
//           date: "",
//           service: "",
//           Particulars: "",
//           quantity: "",
//           unit: "",
//           rate: 0,
//           amount: 0,
//           HSNCODE: "",
//           TaxRate: 0,
//           TaxID: null,
//           TaxAmount: 0,
//         });
//       }
//       setInvoice({ ...invoice, details: updated });
//       setFilteredServices(services);
//     }
//   };

//   // ── Duty Slip Fare Flow ──
//   const handleDutySlipIdSubmit = async (index, dutySlipId) => {
//     if (!dutySlipId) return;

//     try {
//       const slipRes = await axios.get(
//         `${BASE_API_URL}/dutyslip/get/${dutySlipId}`,
//       );
//       if (!slipRes.data?.success) {
//         toast.error("Duty Slip not found!");
//         return;
//       }
//       const slip = slipRes.data.data;

//       const listRes = await axios.get(
//         `${BASE_API_URL}/dutyslip/fares/list/${encodeURIComponent(
//           slip.vehicleType,
//         )}?CompID=${CompID}`,
//       );

//       const packages = listRes.data?.success ? listRes.data.data : [];

//       if (!packages.length) {
//         toast.error("No fare package found for this vehicle type!");
//         return;
//       }

//       if (packages.length === 1) {
//         await applyFareToRow(index, slip, packages[0], dutySlipId);
//       } else {
//         setPendingSlipByRow((prev) => ({
//           ...prev,
//           [index]: { slip, dutySlipId },
//         }));
//         setFarePackagesByRow((prev) => ({ ...prev, [index]: packages }));
//         toast.info("Multiple fare packages found — please select one below.");
//       }
//     } catch (err) {
//       console.error("Duty Slip Fare Error:", err);
//       toast.error(
//         err.response?.data?.message || "Failed to fetch duty slip details!",
//       );
//     }
//   };

//   const applyFareToRow = async (index, slip, fare, dutySlipId) => {
//     // ── Formula ──
//     const totalMinutes = (Number(slip.totalTime) || 0) * 60;
//     const includedMinutes = (Number(fare.IncludedHrs) || 0) * 60;

//     const extraKM = Math.max(
//       0,
//       (Number(slip.totalKm) || 0) - (Number(fare.IncludedKM) || 0),
//     );
//     const extraMinutes = Math.max(0, totalMinutes - includedMinutes);

//     const kmCharge =
//       extraKM *
//       ((Number(fare.FuelRateKM) || 0) + (Number(fare.LubRateKM) || 0));
//     const timeCharge = extraMinutes * (Number(fare.TimeRatePM) || 0);
//     const fareAmount = (Number(fare.BaseFare) || 0) + kmCharge + timeCharge;

//     const formattedDate = updatedDate(slip.dutyslipDate);

//     // ── Build breakdown string ──
//     const journeyParts = [`${slip.totalKm}km`, `${slip.totalTime}hrs`];
//     const chargeParts = [`Base ₹${Number(fare.BaseFare).toFixed(0)}`];
//     if (kmCharge > 0) chargeParts.push(`Extra KM ₹${Math.round(kmCharge)}`);
//     if (timeCharge > 0)
//       chargeParts.push(`Extra Time ₹${Math.round(timeCharge)}`);
//     const breakdown = `${journeyParts.join(", ")} (${chargeParts.join(" + ")})`;

//     // ── Update row ──
//     const updated = [...invoice.details];
//     updated[index] = {
//       ...updated[index],
//       date: formattedDate || updated[index].date,
//       service: "Taxi Fare",
//       Particulars: `${
//         fare.PackageName || "Taxi Fare"
//       } - Duty Slip #${dutySlipId} — ${breakdown}`,
//       quantity: 1,
//       unit: "trip",
//       rate: Math.round(fareAmount * 100) / 100,
//       amount: Math.round(fareAmount * 100) / 100,
//       HSNCODE: fare.HSNCODE || "",
//       TaxRate: fare.TaxRate || 0,
//       TaxID: fare.TaxID || null,
//       TaxAmount:
//         Math.round(((fareAmount * (fare.TaxRate || 0)) / 100) * 100) / 100,
//     };

//     if (index === updated.length - 1) {
//       updated.push({
//         date: "",
//         service: "",
//         Particulars: "",
//         quantity: "",
//         unit: "",
//         rate: 0,
//         amount: 0,
//         HSNCODE: "",
//         TaxRate: 0,
//         TaxID: null,
//         TaxAmount: 0,
//       });
//     }

//     setInvoice({ ...invoice, details: updated });
//     setTaxiFareRows((prev) => ({ ...prev, [index]: false }));
//     setFarePackagesByRow((prev) => ({ ...prev, [index]: [] }));
//     setPendingSlipByRow((prev) => ({ ...prev, [index]: null }));
//     setSelectedFareIdByRow((prev) => ({ ...prev, [index]: "" }));

//     toast.success(`Fare calculated: ₹${fareAmount.toFixed(2)}`);
//   };

//   const handleFarePackageSelect = async (index, fareId) => {
//     setSelectedFareIdByRow((prev) => ({ ...prev, [index]: fareId }));

//     const pending = pendingSlipByRow[index];
//     const packages = farePackagesByRow[index] || [];
//     const chosenFare = packages.find((p) => String(p.ID) === String(fareId));

//     if (!pending || !chosenFare) return;

//     await applyFareToRow(index, pending.slip, chosenFare, pending.dutySlipId);
//   };

//   const updatedDate = (dStr) => {
//     if (!dStr) return "";
//     try {
//       return new Date(dStr).toISOString().split("T")[0];
//     } catch {
//       return dStr;
//     }
//   };

//   // ── SAVE (fixed field mapping) ──
//   const saveInvoice = async () => {
//     try {
//       const payload = {
//         ...invoice,
//         details: invoice.details
//           .filter((d) => d.date && d.date.trim() !== "")
//           .map((d) => ({
//             Date: d.date,
//             Qty: d.quantity,
//             Rate: d.rate,
//             Amount: d.amount,
//             Units: d.unit,
//             Services: d.service,
//             Particulars: d.Particulars,
//             TaxID: d.TaxID,
//             TaxRate: d.TaxRate,
//             HSNCODE: d.HSNCODE,
//           })),
//       };

//       const res = await apiWithLog({
//         method: "PUT",
//         url: `${BASE_API_URL}invoice/update/${CompID}/${InvoiceNo}`,
//         data: payload,
//         module: "Billsinvoice",
//         action: "E",
//       });

//       if (res.data.success) toast.success("Invoice updated successfully!");
//       else toast.error("Failed to update invoice!");
//     } catch (err) {
//       console.error(err);
//       toast.error("Error saving invoice!");
//     }
//   };

//   if (loading) return <div>Loading...</div>;
//   if (!invoice) return <h3>No invoice found!</h3>;

//   return (
//     <div className="Payment_div invoice-page">
//       <ToastContainer position="top-right" autoClose={3000} />
//       <div
//         style={{
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <h6
//           style={{
//             margin: 0,
//             textAlign: "center",
//             flexGrow: 1,
//             fontWeight: "bold",
//           }}
//         >
//           Invoice Details
//         </h6>
//         <div style={{ position: "absolute", right: 10, top: 0 }}>
//           <button className="save-btn" onClick={saveInvoice}>
//             💾 Save
//           </button>
//           <button
//             className="save-btn"
//             onClick={() => navigate(-1)}
//             style={{ marginLeft: "10px" }}
//           >
//             🔙 Back
//           </button>
//         </div>
//       </div>
//       <br />

//       {/* Invoice Form */}
//       <div className="invoice-form">
//         <div className="form-grid">
//           {/* LEFT COLUMN */}
//           <div className="form-column">
//             <div className="form-row">
//               <label>Invoice No</label>
//               <input
//                 type="text"
//                 value={invoice.InvoiceNo || ""}
//                 onChange={(e) => handleInputChange("InvoiceNo", e.target.value)}
//                 style={{ width: "160px", flex: "0 0 auto" }}
//               />
//             </div>
//             <div className="form-row">
//               <label>Invoice Date</label>
//               <DatePicker
//                 selected={new Date(invoice.InvoiceDate)}
//                 onChange={(date) =>
//                   handleInputChange(
//                     "InvoiceDate",
//                     date ? date.toISOString().split("T")[0] : "",
//                   )
//                 }
//                 dateFormat="yyyy-MM-dd"
//               />
//             </div>
//             <div className="form-row">
//               <label>Party Name</label>
//               <select
//                 value={invoice.PartyName || ""}
//                 onChange={handlePartySelect}
//               >
//                 <option value="">Select Party</option>
//                 {parties.map((p, i) => (
//                   <option key={i} value={p.HEADName}>
//                     {p.HEADName}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-row">
//               <label>Address</label>
//               <textarea
//                 rows="2"
//                 value={invoice.Address || ""}
//                 onChange={(e) => handleInputChange("Address", e.target.value)}
//               />
//             </div>
//             <div className="state-row">
//               <div className="form-row">
//                 <label>State</label>
//                 <input
//                   type="text"
//                   value={invoice.State || ""}
//                   onChange={(e) => handleInputChange("State", e.target.value)}
//                 />
//               </div>
//               <div className="form-row">
//                 <label>State Code</label>
//                 <input
//                   type="text"
//                   value={invoice.StateCode || ""}
//                   onChange={(e) =>
//                     handleInputChange("StateCode", e.target.value)
//                   }
//                 />
//               </div>
//             </div>
//             <div className="form-row">
//               <label>GSTIN</label>
//               <input
//                 type="text"
//                 value={invoice.GSTIN || ""}
//                 onChange={(e) => handleInputChange("GSTIN", e.target.value)}
//               />
//             </div>
//           </div>

//           {/* RIGHT COLUMN */}
//           <div className="form-column">
//             <div className="form-row">
//               <label>Reverse Charge</label>
//               <select
//                 value={invoice.ReverseCharges ? "Yes" : "No"}
//                 onChange={(e) =>
//                   handleInputChange("ReverseCharges", e.target.value === "Yes")
//                 }
//                 style={{ width: "130px", flex: "0 0 auto" }}
//               >
//                 <option>No</option>
//                 <option>Yes</option>
//               </select>
//             </div>

//             <div className="form-row">
//               <label>Duty Slip No</label>
//               <input
//                 type="text"
//                 value={invoice.DutySlipNo || ""}
//                 onChange={(e) =>
//                   handleInputChange("DutySlipNo", e.target.value)
//                 }
//                 style={{ width: "130px", flex: "0 0 auto" }}
//               />
//             </div>

//             <div className="form-row">
//               <label>Vehicle No</label>
//               <select
//                 value={invoice.VehicleNo || ""}
//                 onChange={handleVehicleSelect}
//                 style={{ width: "130px", flex: "0 0 auto" }}
//               >
//                 <option value="">Select Vehicle</option>
//                 {vehicles.map((v, i) => (
//                   <option key={i} value={v.VehicleNo}>
//                     {v.VehicleNo}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="form-row">
//               <label>Vehicle Type</label>
//               <input
//                 type="text"
//                 value={invoice.VehicleType || ""}
//                 readOnly
//                 style={{
//                   width: "130px",
//                   backgroundColor: "#f3f3f3",
//                   flex: "0 0 auto",
//                 }}
//               />
//             </div>

//             <div className="form-row">
//               <label>Guest</label>
//               <input
//                 type="text"
//                 value={invoice.Guest || ""}
//                 onChange={(e) => handleInputChange("Guest", e.target.value)}
//                 style={{ width: "250px", flex: "0 0 auto" }}
//               />
//             </div>

//             <div className="form-row">
//               <label>Booked By</label>
//               <input
//                 type="text"
//                 value={invoice.BookedBy || ""}
//                 onChange={(e) => handleInputChange("BookedBy", e.target.value)}
//                 style={{ width: "250px", flex: "0 0 auto" }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* SERVICE DETAILS TABLE */}
//       <div className="invoice-preview">
//         <table className="invoice-table">
//           <thead>
//             <tr>
//               <th>Date</th>
//               <th>Service</th>
//               <th>Particulars</th>
//               <th>Qty</th>
//               <th>Units</th>
//               <th>Rate</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {invoice.details.length === 0 && (
//               <tr>
//                 <td colSpan="7" style={{ textAlign: "center" }}>
//                   No items found
//                 </td>
//               </tr>
//             )}
//             {invoice.details.map((item, index) => (
//               <tr key={index}>
//                 <td>
//                   <DatePicker
//                     selected={item.date ? new Date(item.date) : null}
//                     onChange={(date) =>
//                       handleDetailChange(
//                         index,
//                         "date",
//                         date ? date.toISOString().split("T")[0] : "",
//                       )
//                     }
//                     dateFormat="yyyy-MM-dd"
//                     placeholderText="Select date"
//                     isClearable
//                   />
//                 </td>
//                 <td className="service-cell">
//                   <div className="service-dropdown-wrapper">
//                     <input
//                       type="text"
//                       value={item.service}
//                       onChange={(e) =>
//                         handleServiceChange(index, e.target.value)
//                       }
//                       onFocus={() => setActiveServiceRow(index)}
//                       onBlur={() =>
//                         setTimeout(() => setActiveServiceRow(null), 150)
//                       }
//                       placeholder="Select or type..."
//                     />
//                     {activeServiceRow === index && (
//                       <ul className="service-dropdown-list">
//                         <li
//                           onMouseDown={() =>
//                             handleServiceChange(index, "Taxi Fare")
//                           }
//                         >
//                           🚕 Taxi Fare (from Duty Slip)
//                         </li>
//                         {filteredServices.map((s, i) => (
//                           <li
//                             key={i}
//                             onMouseDown={() =>
//                               handleServiceChange(index, s.ServiceName)
//                             }
//                           >
//                             {s.ServiceName}
//                           </li>
//                         ))}
//                       </ul>
//                     )}
//                   </div>

//                   {/* Duty Slip ID input (only when Taxi Fare is selected) */}
//                   {taxiFareRows[index] && (
//                     <input
//                       type="text"
//                       className="duty-slip-input"
//                       placeholder="Enter Duty Slip ID & press Enter"
//                       value={dutySlipIdInput[index] || ""}
//                       onChange={(e) =>
//                         setDutySlipIdInput((prev) => ({
//                           ...prev,
//                           [index]: e.target.value,
//                         }))
//                       }
//                       onKeyDown={(e) => {
//                         if (e.key === "Enter") {
//                           handleDutySlipIdSubmit(index, dutySlipIdInput[index]);
//                         }
//                       }}
//                       style={{
//                         marginTop: "4px",
//                         fontSize: "12px",
//                         width: "100%",
//                         padding: "4px 8px",
//                       }}
//                     />
//                   )}

//                   {/* Package picker for multiple fares */}
//                   {farePackagesByRow[index]?.length > 1 && (
//                     <select
//                       value={selectedFareIdByRow[index] || ""}
//                       onChange={(e) =>
//                         handleFarePackageSelect(index, e.target.value)
//                       }
//                       style={{
//                         marginTop: "4px",
//                         fontSize: "12px",
//                         width: "100%",
//                         padding: "4px 8px",
//                       }}
//                     >
//                       <option value="">Select fare package...</option>
//                       {farePackagesByRow[index].map((pkg) => (
//                         <option key={pkg.ID} value={pkg.ID}>
//                           {pkg.PackageName} (Base ₹{pkg.BaseFare})
//                         </option>
//                       ))}
//                     </select>
//                   )}
//                 </td>
//                 <td>
//                   <input
//                     type="text"
//                     value={item.Particulars || ""}
//                     title={item.Particulars || ""} // ← full text on hover
//                     onChange={(e) =>
//                       handleDetailChange(index, "Particulars", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td>
//                   <input
//                     type="number"
//                     value={item.quantity || ""}
//                     onChange={(e) =>
//                       handleDetailChange(index, "quantity", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td>
//                   <input
//                     type="text"
//                     value={item.unit || ""}
//                     onChange={(e) =>
//                       handleDetailChange(index, "unit", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td>
//                   <input
//                     type="number"
//                     value={item.rate || ""}
//                     onChange={(e) =>
//                       handleDetailChange(index, "rate", e.target.value)
//                     }
//                   />
//                 </td>
//                 <td>{item.amount?.toFixed(2)}</td>
//               </tr>
//             ))}
//           </tbody>
//           <tfoot>
//             <tr>
//               <td colSpan="6" style={{ textAlign: "right" }}>
//                 <strong>Total Taxable Amount:</strong>
//               </td>
//               <td>₹{totalAmount.toFixed(2)}</td>
//             </tr>
//             <tr>
//               <td colSpan="6" style={{ textAlign: "right" }}>
//                 <strong>Tax Amount:</strong>
//               </td>
//               <td>₹{taxTotal.toFixed(2)}</td>
//             </tr>
//             <tr>
//               <td colSpan="6" style={{ textAlign: "right" }}>
//                 <strong>Grand Total:</strong>
//               </td>
//               <td>₹{grandTotal.toFixed(2)}</td>
//             </tr>
//           </tfoot>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default InvoiceDetails;
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { showToast } from "../utils/customToast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Invoice.css";

const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

// Helper: build a breakdown string for a duty slip (matches backend format)
const getBreakdownString = (slip) => {
  const totalMinutes = (Number(slip.TotalTime) || 0) * 60;
  const includedMinutes = (Number(slip.IncludedHrs) || 0) * 60;
  const extraKM = Math.max(0, (Number(slip.TotalKM) || 0) - (Number(slip.IncludedKM) || 0));
  const extraMinutes = Math.max(0, totalMinutes - includedMinutes);
  const kmRate = (Number(slip.FuelRateKM) || 0) + (Number(slip.LubRateKM) || 0);
  const kmCharge = extraKM * kmRate;
  const timeRate = Number(slip.TimeRatePM) || 0;
  const timeCharge = (extraMinutes / 60) * timeRate;
  const baseFare = Number(slip.BaseFare) || 0;

  const parking = Number(slip.Parking || slip.parking) || 0;
  const driverAllowance = Number(slip.DriverAllowance || slip.driverAllowance) || 0;
  const tollTax = Number(slip.TollTax || slip.tollTax) || 0;
  const nightCharges = Number(slip.NightCharges || slip.nightCharges) || 0;

  const parts = [`Base ₹${baseFare.toFixed(0)}`];
  const addOnParts = [];

  if (extraKM > 0) {
    addOnParts.push(`${extraKM}km extra × ₹${kmRate.toFixed(2)}/km = ₹${Math.round(kmCharge).toLocaleString("en-IN")}`);
  }
  if (extraMinutes > 0) {
    const extraHrs = (extraMinutes / 60).toFixed(2);
    addOnParts.push(`${extraHrs}hrs extra × ₹${timeRate.toFixed(2)}/hr = ₹${Math.round(timeCharge).toLocaleString("en-IN")}`);
  }
  if (parking > 0) {
    addOnParts.push(`Parking = ₹${Math.round(parking).toLocaleString("en-IN")}`);
  }
  if (driverAllowance > 0) {
    addOnParts.push(`Driver Allowance = ₹${Math.round(driverAllowance).toLocaleString("en-IN")}`);
  }
  if (tollTax > 0) {
    addOnParts.push(`Toll Tax = ₹${Math.round(tollTax).toLocaleString("en-IN")}`);
  }
  if (nightCharges > 0) {
    addOnParts.push(`Night Charges = ₹${Math.round(nightCharges).toLocaleString("en-IN")}`);
  }

  if (addOnParts.length) {
    parts.push(`Add-on: ${addOnParts.join(" + ")}`);
  }

  const total = baseFare + kmCharge + timeCharge + parking + driverAllowance + tollTax + nightCharges;
  return `${slip.TotalKM}km, ${slip.TotalTime}hrs — ${parts.join(" + ")} = ₹${Math.round(total).toLocaleString("en-IN")}`;
};

const InvoiceDetails = () => {
  const { CompID, '*': invoiceNoFromRoute } = useParams();
  // invoiceNoFromRoute captures the full invoice number including slashes (e.g. DTT/8463/2026-2027)
  const navigate = useNavigate();

  // ----- State -----
  const [loading, setLoading] = useState(false);
  const [parties, setParties] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);

  // Invoice header fields
  const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split("T")[0]);
  const [partyName, setPartyName] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [driverName, setDriverName] = useState("");
  const [guest, setGuest] = useState("");
  const [bookedBy, setBookedBy] = useState("");
  const [reverseCharges, setReverseCharges] = useState(false);

  // Service selection
  const [selectedService, setSelectedService] = useState("");
  const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);

  // Duty slip related
  const [availableSlips, setAvailableSlips] = useState([]);
  const [selectedSlipIds, setSelectedSlipIds] = useState([]);

  // Package related
  const [packages, setPackages] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState("");

  // Manual invoice lines (for services other than the two special ones)
  const [invoiceLines, setInvoiceLines] = useState([
    { date: "", service: "", particulars: "", qty: 1, unit: "trip", rate: 0, amount: 0 }
  ]);

  // ----- Load dropdowns on mount -----
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [partyRes, vehicleRes, serviceRes] = await Promise.all([
          axios.get(`${BASE_API_URL}/invoice/dropdowns/${CompID}`),
          axios.get(`${BASE_API_URL}/invoice/vehicles/${CompID}`),
          axios.get(`${BASE_API_URL}/invoice/services/${CompID}`),
        ]);
        if (partyRes.data.success) setParties(partyRes.data.data);
        if (vehicleRes.data.success) setVehicles(vehicleRes.data.data);
        if (serviceRes.data.success) {
          setServices(serviceRes.data.data);
          setFilteredServices(serviceRes.data.data);
        }
      } catch (err) {
        console.error(err);
        showToast.error("Failed to load dropdown data");
      }
    };
    fetchDropdowns();
  }, [CompID]);

  // ----- Fetch data when service changes -----
  useEffect(() => {
    // Reset dependent selections
    setSelectedSlipIds([]);
    setSelectedPackageId("");
    setAvailableSlips([]);
    setPackages([]);

    if (selectedService === "Transport with Duty Slip") {
      fetchUninvoicedSlips();
    } else if (selectedService === "Transport without Duty Slip") {
      fetchPackages();
    }
  }, [selectedService, partyName]);

  // ----- Fetch uninvoiced duty slips -----
  const fetchUninvoicedSlips = async () => {
    try {
      const url = `${BASE_API_URL}/invoice/duty-slips/uninvoiced/${CompID}${partyName ? `?partyName=${encodeURIComponent(partyName)}` : ""}`;
      const res = await axios.get(url);
      if (res.data.success) {
        setAvailableSlips(res.data.data);
      } else {
        showToast.error(res.data.message || "Failed to load duty slips");
      }
    } catch (err) {
      console.error(err);
      showToast.error("Error fetching duty slips");
    }
  };

  // ----- Fetch fare packages -----
  const fetchPackages = async () => {
    try {
      const res = await axios.get(`${BASE_API_URL}/invoice/packages/${CompID}`);
      if (res.data.success) {
        setPackages(res.data.data);
      } else {
        showToast.error(res.data.message || "Failed to load packages");
      }
    } catch (err) {
      console.error(err);
      showToast.error("Error fetching packages");
    }
  };

  // ----- Toggle slip selection -----
  const toggleSlip = (slipId) => {
    setSelectedSlipIds(prev =>
      prev.includes(slipId) ? prev.filter(id => id !== slipId) : [...prev, slipId]
    );
  };

  // ----- Auto-fill header from selected duty slips -----
  useEffect(() => {
    if (selectedSlipIds.length > 0) {
      const first = availableSlips.find(s => selectedSlipIds.includes(s.DutySlipID));
      if (first) {
        if (first.VehicleNo) setVehicleNo(first.VehicleNo);
        if (first.VehicleType) setVehicleType(first.VehicleType);
        if (first.DriverName) setDriverName(first.DriverName);
        if (first.ClientName && !guest) setGuest(first.ClientName);
      }
    }
  }, [selectedSlipIds, availableSlips]);

  // ----- Compute summary for selected slips -----
  const selectedSlipsData = availableSlips.filter(s => selectedSlipIds.includes(s.DutySlipID));
  const totalKm = selectedSlipsData.reduce((sum, s) => sum + (s.TotalKM || 0), 0);
  const totalTime = selectedSlipsData.reduce((sum, s) => sum + (s.TotalTime || 0), 0);
  const totalAmount = selectedSlipsData.reduce((sum, s) => sum + (s.InvoiceAmount || 0), 0);

  // ----- Service dropdown handlers -----
  const handleServiceInputChange = (value) => {
    setSelectedService(value);
    const filtered = services.filter(s =>
      s.ServiceName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredServices(filtered);
    setServiceDropdownOpen(true);
  };

  const handleServiceSelect = (serviceName) => {
    setSelectedService(serviceName);
    setServiceDropdownOpen(false);
  };

  // ----- Manual line handlers -----
  const handleLineChange = (index, field, value) => {
    const updated = [...invoiceLines];
    updated[index][field] = value;
    if (field === "qty" || field === "rate") {
      const qty = parseFloat(updated[index].qty) || 0;
      const rate = parseFloat(updated[index].rate) || 0;
      updated[index].amount = qty * rate;
    }
    setInvoiceLines(updated);
  };

  const addLine = () => {
    setInvoiceLines([
      ...invoiceLines,
      { date: invoiceDate || "", service: "", particulars: "", qty: 1, unit: "trip", rate: 0, amount: 0 }
    ]);
  };

  const removeLine = (index) => {
    if (invoiceLines.length === 1) return showToast.warn("At least one line required");
    const updated = invoiceLines.filter((_, i) => i !== index);
    setInvoiceLines(updated);
  };

  // ----- Save invoice -----
  const saveInvoice = async () => {
    if (loading) return;
    let transportMode = "";
    let dutySlipIds = [];
    let packageId = null;
    let details = [];

    if (selectedService === "Transport with Duty Slip") {
      transportMode = "Transport with Duty Slip";
      dutySlipIds = selectedSlipIds;
      if (dutySlipIds.length === 0) {
        showToast.error("Please select at least one duty slip");
        return;
      }
    } else if (selectedService === "Transport without Duty Slip") {
      transportMode = "Transport without Duty Slip";
      packageId = selectedPackageId ? parseInt(selectedPackageId) : null;
      if (!packageId) {
        showToast.error("Please select a fare package");
        return;
      }
    } else {
      // Manual lines
      transportMode = selectedService || "Other";
      details = invoiceLines
        .filter(line => line.service.trim() !== "")
        .map(line => ({
          Date: line.date || invoiceDate,
          Qty: line.qty || 1,
          Rate: line.rate || 0,
          Amount: line.amount || 0,
          Units: line.unit || "trip",
          Services: line.service,
          Particulars: line.particulars || "",
        }));
      if (details.length === 0) {
        showToast.error("Please add at least one line item");
        return;
      }
    }

    if (!partyName) {
      showToast.error("Please select a party");
      return;
    }

    const payload = {
      CompID: parseInt(CompID),
      PartyName: partyName,
      InvoiceDate: invoiceDate,
      VehicleNo: vehicleNo || null,
      VehicleType: vehicleType || null,
      DriverName: driverName || null,
      Guest: guest || null,
      BookedBy: bookedBy || null,
      ReverseCharges: reverseCharges,
      TransportMode: transportMode,
      DutySlipIds: dutySlipIds,
      PackageId: packageId,
      details: details,
    };

    setLoading(true);
    try {
      const res = await axios.post(`${BASE_API_URL}/invoice/create`, payload);
      if (res.status === 201) {
        showToast.save(`Invoice ${res.data.InvoiceNoDisplay} created successfully!`);
        // Navigate to invoice-details — the route uses a wildcard so slashes in the invoice number are handled
        navigate(`/invoice-details/${CompID}/${res.data.InvoiceNoDisplay}`);
      } else {
        showToast.error(res.data.message || "Failed to create invoice");
      }
    } catch (err) {
      console.error(err);
      showToast.error(err.response?.data?.error || "Server error");
    } finally {
      setLoading(false);
    }
  };

  // ----- Render -----
  return (
    <div className="Payment_div invoice-page">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h6 style={{ margin: 0, fontWeight: "bold" }}>New Invoice</h6>
        <div>
          <button className="save-btn" onClick={saveInvoice} disabled={loading}>
            {loading ? "Saving..." : "💾 Save"}
          </button>
          <button className="save-btn" onClick={() => navigate(-1)} style={{ marginLeft: 10 }}>
            🔙 Back
          </button>
        </div>
      </div>

      {/* ----- Invoice Header ----- */}
      <div className="invoice-form">
        <div className="form-grid">
          <div className="form-column">
            <div className="form-row">
              <label>Invoice Date</label>
              <DatePicker
                selected={new Date(invoiceDate)}
                onChange={(date) => setInvoiceDate(date ? date.toISOString().split("T")[0] : "")}
                dateFormat="yyyy-MM-dd"
              />
            </div>
            <div className="form-row">
              <label>Party Name</label>
              <select value={partyName} onChange={(e) => setPartyName(e.target.value)}>
                <option value="">Select Party</option>
                {parties.map((p, i) => (
                  <option key={i} value={p.HEADName}>{p.HEADName}</option>
                ))}
              </select>
            </div>
            <div className="form-row">
              <label>Vehicle No</label>
              <select value={vehicleNo} onChange={(e) => {
                const val = e.target.value;
                setVehicleNo(val);
                const v = vehicles.find(v => v.VehicleNo === val);
                setVehicleType(v ? v.VehicleTypeName : "");
              }}>
                <option value="">Select Vehicle</option>
                {vehicles.map((v, i) => (
                  <option key={i} value={v.VehicleNo}>{v.VehicleNo}</option>
                ))}
              </select>
            </div>
            <div className="form-row">
              <label>Vehicle Type</label>
              <input type="text" value={vehicleType} readOnly style={{ backgroundColor: "#f3f3f3" }} />
            </div>
            <div className="form-row">
              <label>Driver Name</label>
              <input type="text" value={driverName} onChange={(e) => setDriverName(e.target.value)} placeholder="Driver Name" />
            </div>
          </div>
          <div className="form-column">
            <div className="form-row">
              <label>Reverse Charge</label>
              <select value={reverseCharges ? "Yes" : "No"} onChange={(e) => setReverseCharges(e.target.value === "Yes")}>
                <option>No</option>
                <option>Yes</option>
              </select>
            </div>
            <div className="form-row">
              <label>Guest</label>
              <input type="text" value={guest} onChange={(e) => setGuest(e.target.value)} />
            </div>
            <div className="form-row">
              <label>Booked By</label>
              <input type="text" value={bookedBy} onChange={(e) => setBookedBy(e.target.value)} />
            </div>
          </div>
        </div>
      </div>

      {/* ----- Service Selection (with autocomplete) ----- */}
      <div style={{ margin: "20px 0" }}>
        <label style={{ marginRight: 10 }}>Service:</label>
        <div className="service-dropdown-wrapper" style={{ display: "inline-block", position: "relative" }}>
          <input
            type="text"
            value={selectedService}
            onChange={(e) => handleServiceInputChange(e.target.value)}
            onFocus={() => setServiceDropdownOpen(true)}
            onBlur={() => setTimeout(() => setServiceDropdownOpen(false), 150)}
            placeholder="Type or select service..."
            style={{ width: 300, padding: "6px 12px" }}
          />
          {serviceDropdownOpen && (
            <ul className="service-dropdown-list" style={{ position: "absolute", zIndex: 10, background: "white", border: "1px solid #ccc", width: "100%", maxHeight: 200, overflowY: "auto", listStyle: "none", padding: 0, margin: 0 }}>
              {filteredServices.map((s, i) => (
                <li key={i} onMouseDown={() => handleServiceSelect(s.ServiceName)} style={{ padding: "8px 12px", cursor: "pointer" }}>
                  {s.ServiceName}
                </li>
              ))}
              {filteredServices.length === 0 && <li style={{ padding: "8px 12px" }}>No services found</li>}
            </ul>
          )}
        </div>
      </div>

      {/* ----- Conditional: Transport with Duty Slip ----- */}
      {selectedService === "Transport with Duty Slip" && (
        <div style={{ border: "1px solid #ddd", padding: 16, borderRadius: 4, marginBottom: 20 }}>
          <h5>Select Duty Slips</h5>
          {availableSlips.length === 0 ? (
            <p>No uninvoiced duty slips available for this party.</p>
          ) : (
            <div style={{ maxHeight: 300, overflowY: "auto" }}>
              {availableSlips.map(slip => (
                <div key={slip.DutySlipID} style={{ display: "flex", alignItems: "center", padding: "4px 0" }}>
                  <input
                    type="checkbox"
                    checked={selectedSlipIds.includes(slip.DutySlipID)}
                    onChange={() => toggleSlip(slip.DutySlipID)}
                  />
                  <span style={{ marginLeft: 8 }}>
                    <strong>#{slip.DutySlipID}</strong> – {slip.PartyName} – {slip.TotalKM}km, {slip.TotalTime}hrs – ₹{slip.InvoiceAmount}
                  </span>
                </div>
              ))}
            </div>
          )}

          {/* Summary of selected slips */}
          {selectedSlipIds.length > 0 && (
            <div style={{ marginTop: 16, borderTop: "1px solid #eee", paddingTop: 12 }}>
              <h5>Summary of Selected Slips</h5>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Slip</th>
                    <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Total KM</th>
                    <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Total Time</th>
                    <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Amount</th>
                    <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Breakdown</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedSlipsData.map(s => (
                    <tr key={s.DutySlipID}>
                      <td style={{ padding: "4px 8px" }}>#{s.DutySlipID}</td>
                      <td style={{ padding: "4px 8px" }}>{s.TotalKM}</td>
                      <td style={{ padding: "4px 8px" }}>{s.TotalTime} hrs</td>
                      <td style={{ padding: "4px 8px" }}>₹{s.InvoiceAmount}</td>
                      <td style={{ padding: "4px 8px" }}>{getBreakdownString(s)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 8px" }}>Totals</td>
                    <td style={{ fontWeight: "bold", padding: "4px 8px" }}>{totalKm}</td>
                    <td style={{ fontWeight: "bold", padding: "4px 8px" }}>{totalTime} hrs</td>
                    <td style={{ fontWeight: "bold", padding: "4px 8px" }}>₹{totalAmount}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ----- Conditional: Transport without Duty Slip ----- */}
      {selectedService === "Transport without Duty Slip" && (
        <div style={{ border: "1px solid #ddd", padding: 16, borderRadius: 4, marginBottom: 20 }}>
          <h5>Select Fare Package</h5>
          <select value={selectedPackageId} onChange={(e) => setSelectedPackageId(e.target.value)} style={{ width: "100%", padding: "8px" }}>
            <option value="">-- Choose Package --</option>
            {packages.map(pkg => (
              <option key={pkg.ID} value={pkg.ID}>
                {pkg.PackageName} – Base ₹{pkg.BaseFare} (Incl. {pkg.IncludedKM}km / {pkg.IncludedHrs}hrs)
              </option>
            ))}
          </select>
          {selectedPackageId && (
            <div style={{ marginTop: 12 }}>
              <p><strong>Selected:</strong> {packages.find(p => p.ID === parseInt(selectedPackageId))?.PackageName}</p>
              <p><strong>Amount:</strong> ₹{packages.find(p => p.ID === parseInt(selectedPackageId))?.BaseFare}</p>
            </div>
          )}
        </div>
      )}

      {/* ----- Manual Invoice Lines (for other services) ----- */}
      {selectedService !== "Transport with Duty Slip" && selectedService !== "Transport without Duty Slip" && (
        <div>
          <h5>Invoice Lines</h5>
          <table className="invoice-table" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Service</th>
                <th>Particulars</th>
                <th>Qty</th>
                <th>Units</th>
                <th>Rate</th>
                <th>Amount</th>
                <th style={{ width: 50 }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {invoiceLines.map((line, idx) => {
                const isDutySvc = line.service && (
                  line.service.trim().toLowerCase() === "transport with duty slip" ||
                  line.service.trim().toLowerCase() === "transport without duty slip" ||
                  line.service.trim().toLowerCase().includes("duty slip")
                );
                return (
                  <tr key={idx}>
                    <td>
                      {isDutySvc ? (
                        <DatePicker
                          selected={line.date ? new Date(line.date) : null}
                          onChange={(date) => handleLineChange(idx, "date", date ? date.toISOString().split("T")[0] : "")}
                          dateFormat="yyyy-MM-dd"
                          placeholderText="Date"
                          isClearable
                        />
                      ) : null}
                    </td>
                  <td>
                    <input
                      type="text"
                      value={line.service}
                      onChange={(e) => handleLineChange(idx, "service", e.target.value)}
                      placeholder="Service"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={line.particulars}
                      onChange={(e) => handleLineChange(idx, "particulars", e.target.value)}
                      placeholder="Particulars"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={line.qty}
                      onChange={(e) => handleLineChange(idx, "qty", parseFloat(e.target.value) || 0)}
                      style={{ width: 60 }}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={line.unit}
                      onChange={(e) => handleLineChange(idx, "unit", e.target.value)}
                      style={{ width: 80 }}
                      placeholder="Unit"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={line.rate}
                      onChange={(e) => handleLineChange(idx, "rate", parseFloat(e.target.value) || 0)}
                      style={{ width: 80 }}
                    />
                  </td>
                  <td>{line.amount.toFixed(2)}</td>
                  <td>
                    <button onClick={() => removeLine(idx)} style={{ background: "red", color: "white", border: "none", borderRadius: 4, padding: "2px 8px" }}>
                      ✕
                    </button>
                  </td>
                </tr>
              );
            })}
            </tbody>
          </table>
          <button onClick={addLine} style={{ marginTop: 10 }}>+ Add Row</button>
        </div>
      )}

      {/* ----- Totals preview ----- */}
      {selectedService === "Transport with Duty Slip" && selectedSlipIds.length > 0 && (
        <div style={{ marginTop: 20, textAlign: "right", borderTop: "1px solid #ddd", paddingTop: 10 }}>
          <div><strong>Total Taxable Amount:</strong> ₹{totalAmount.toFixed(2)}</div>
          <div><strong>Tax Amount:</strong> ₹0.00</div>
          <div><strong>Grand Total:</strong> ₹{totalAmount.toFixed(2)}</div>
        </div>
      )}

      {selectedService === "Transport without Duty Slip" && selectedPackageId && (
        <div style={{ marginTop: 20, textAlign: "right", borderTop: "1px solid #ddd", paddingTop: 10 }}>
          <div><strong>Total Taxable Amount:</strong> ₹{packages.find(p => p.ID === parseInt(selectedPackageId))?.BaseFare || 0}</div>
          <div><strong>Tax Amount:</strong> ₹0.00</div>
          <div><strong>Grand Total:</strong> ₹{packages.find(p => p.ID === parseInt(selectedPackageId))?.BaseFare || 0}</div>
        </div>
      )}

      <div style={{ marginTop: 30, textAlign: "right" }}>
        <button className="save-btn" onClick={saveInvoice} disabled={loading} style={{ padding: "10px 30px" }}>
          {loading ? "Saving..." : "💾 Create Invoice"}
        </button>
      </div>
    </div>
  );
};

export default InvoiceDetails;